import { addCustomer, getCustomerList, searchCustomer, getCustomerById, updateCustomerById, deleteCustomerById } from './CustomerService';
export type { ICreateCustomerRequest } from './ICustomerService';

export const CustomerServices = { addCustomer, getCustomerList, searchCustomer, getCustomerById, updateCustomerById, deleteCustomerById };
